

class Response {
    constructor(jsonResponse) {
        this._success = undefined;
        this._data = {};
        this._parseJsonResponse(jsonResponse)   
    }

    _validateJsonResponse(jsonResponse){
        var hasData = jsonResponse.data !== undefined;
        var hasMeta = jsonResponse.meta !== undefined && jsonResponse.meta.success !== undefined;
        if(!hasData || !hasMeta){
            throw Error("Invalid Response': "+JSON.stringify(jsonResponse));
        }
    }
    
    _parseJsonResponse(jsonResponse){
        this._validateJsonResponse(jsonResponse)
        this._success = jsonResponse.meta.success;
        this._data = jsonResponse.data;
    }
    
    getData(){
        return this._data;
    }
    
    get(key){
        return this._data[key];
    }
    
    isSuccessfull() {
        return this._success;
    }
}